// StockTransfers/TransferedItems.js
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import tw from "tailwind-styled-components";
import {
    BoxContainer,
    BoxTitle,
    BoxHead,
    Underline,
    FilterTableWrapper,
    FilterWrapperWithSearch,
} from "../../Components/Styles/PageStyles";
import { useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import moment from "moment";
import Loading from "../../Components/Loading";
import NotFoundModel from "../../Components/NotFoundModel";
import SearchFilterBox from "../../Components/SearchFilterBox";
import { IoChevronBackOutline, IoFilter } from "react-icons/io5";
import { FaArrowLeft } from "react-icons/fa";
import TransferedItemTable from "../../Components/Inventory/StockTransfers/TransferedItemTable";

const TransferedItems = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { t } = useTranslation();
    const [apiData, setApiData] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [filterType, setFilterType] = useState("");
    const [transferInfo, setTransferInfo] = useState(null);

    const searchOptions = [
        { label: "Item", value: 1 },
    ];

    // Get transfer data from navigation state
    useEffect(() => {
        if (location.state?.transferData) {
            const transfer = location.state.transferData;
            setTransferInfo(transfer);
            // Set entries as apiData for table
            setApiData(transfer.entries || []);
        } else {
            // If no data, redirect back
            navigate("/stock-transfers");
        }
    }, [location.state, navigate]);

    // Handle search
    const handleFilterChange = (values) => {
        setSearchQuery(values.searchQuery || "");
        setFilterType(values.filterType || "");
    };

    // Clear filters
    const handleClearFilters = () => {
        setSearchQuery("");
        setFilterType("");
    };

    // Filter data based on search
    const getFilteredData = () => {
        if (!searchQuery) return apiData;

        return apiData.filter(item =>
            item.itemName?.toLowerCase().includes(searchQuery.toLowerCase())
        );
    };

    const filteredData = getFilteredData();

    return (
        <BoxContainer>
            <BoxHead>
                <div className="flex items-center gap-2">
                    <BackButton onClick={() => navigate("/stock-transfers")}>
                        <IoChevronBackOutline />
                    </BackButton>
                    <BoxTitle className="!mb-0 whitespace-nowrap">
                        Transfered Items
                        <Underline />
                    </BoxTitle>
                </div>

            </BoxHead>

            <FilterTableWrapper>
                <FilterWrapperWithSearch>
                    <div className="flex md:space-x-4 md:flex-row flex-col md:gap-0 gap-4">
                        <SearchFilterBox
                            options={searchOptions}
                            handleFilterChange={handleFilterChange}
                            handleClearFilters={handleClearFilters}
                        />
                    </div>
                </FilterWrapperWithSearch>

                {/* {!isLoading && ( */}
                <TableWrapper>
                    <TransferedItemTable
                        apiData={filteredData}
                        transferInfo={transferInfo}
                    />
                    {filteredData.length === 0 && (
                        <NotFoundModel msg={"No transfered items found."} />
                    )}
                </TableWrapper>
                {/* )} */}
            </FilterTableWrapper>

            {/* {isLoading && <Loading />} */}
        </BoxContainer>
    );
};

const TableWrapper = tw.h1`mt-4 bg-white rounded-md`;
const BackButton = tw.button`p-2 rounded-full bg-gray-100 hover:bg-gray-200 transition-colors duration-200`;

export default TransferedItems;